/**
 * Created by Tamale Dev
 * Description:
 *
 * ------ maintenance history ------
 * Updated by Daniel Wang on 6/27/2022: load splash image by separate api
 */

import { Subject, Subscription } from 'rxjs';
import { IntralinksValidationService } from './intralinks-validation.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'tam-intralinks-validation',
    templateUrl: './intralinks-validation.component.html',
    styleUrls: ['./intralinks-validation.component.scss']
})
export class IntralinksValidationComponent implements OnInit, OnDestroy {
    mfa: object = null;
    mfaSelection = 'phone';
    showing = 'none';
    splash: object = null;
    splashImage: any;

    private _serviceChannel$: Subject<any>;
    private _subscriptions: Subscription[] = [];

    constructor(
        private _sanitizer: DomSanitizer,
        private _validationService: IntralinksValidationService,
    ) { }

    ngOnInit() {
        this._serviceChannel$ = new Subject<any>();
        this._subscriptions.push(
            this._serviceChannel$.subscribe(this._serviceMsgHandler.bind(this))
        );
        this._validationService.register(this._serviceChannel$);
    }

    ngOnDestroy() {
        this._subscriptions.forEach(subscription => {
            if (subscription && !subscription.closed) {
                subscription.unsubscribe();
            }
        });
        this._subscriptions = [];
    }

    acceptSplash() {
        this._serviceChannel$.next({
            type: 'accept',
            payload: this.splash
        });
    }

    backToSendPage() {
        this.showing = 'mfa';
    }

    cancel() {
        this.showing = 'none';
        this._clean();
        this._serviceChannel$.next({
            type: 'cancel',
            payload: null
        });
    }

    chooseMFA() {
        const payload = {
            screenId: this.mfa['screenId'],
            workspaceId: this.mfa['workspaceId'],
        };
        if (this.mfaSelection === 'email') {
            payload['accountEmail'] = this.mfa['email'];
            payload['mobileNumber'] = undefined;
        } else if (this.mfaSelection === 'phone') {
            payload['accountEmail'] = undefined;
            payload['mobileNumber'] = this.mfa['mobile-numbers']['mobile-number'];
        }
        this._serviceChannel$.next({
            type: 'choose',
            payload: payload
        });
        this.showing = 'password';
    }

    submitPassword() {
        this._serviceChannel$.next({
            type: 'password',
            payload: this.mfa['password']
        });
        this.mfa['password'] = '';
    }

    private _clean() {
        this.mfa = null;
        this.splash = null;
        this.mfaSelection = 'phone';
    }

    private _serviceMsgHandler(msg) {
        switch (msg.type) {
            case 'mfa':
                this._clean();
                this.mfa = msg.payload;
                this.showing = 'mfa';
                break;
            case 'splash':
                this._clean();
                this.splash = msg.payload;
                if (!this.splash['splash-text'] || this.splash['splash-text'].length < 1) {
                    this.splash['splash-text'] = 'Default Splash Screen';
                }
                this.splash['content'] = '<span class="content">' + this.splash['splash-text'] + '</span>';
                this.showing = 'splash';
                break;
            case 'splashImage':
                const blob = new Blob([msg.payload], { type: 'image/png' });
                const url = window.URL.createObjectURL(blob);
                this.splashImage = this._sanitizer.bypassSecurityTrustUrl(url);
                break;
            case 'init':
                this.showing = 'init';
                break;
            case 'skip':
            case 'pass':
                this._clean();
                this.showing = 'none';
        }
    }
}
